import { ROLE_EMPLOY_SUPER_ADMIN } from './employ';

const USERS_ROLES = new Map([
  [ROLE_EMPLOY_SUPER_ADMIN, 'Superadmin'],
]);

export default USERS_ROLES;
